import { ProgramsList } from "./ProgramsList/ProgramsList.jsx";

const ProgramsPage = () => {
  return (
    <>
      <section className={"banner"}>
        <div className={"banner__overlay"}>
          <div className={"banner__pattern"} aria-hidden="true" />
          <div className={"banner__body"}>
            <h2
              className={"banner__body__title"}
              style={{ maxWidth: "100%", whiteSpace: "nowrap" }}
            >
              Our <span>Programs</span>
            </h2>
          </div>
        </div>
      </section>

      <ProgramsList />
    </>
  );
};

export default ProgramsPage;
